import { Flex, Box, Text, Button } from "@chakra-ui/react";
import React from "react";
import { mainNav } from "../../Components/Common/Navbar";
import Sidebar from "../../Components/Common/Sidebar";
import Background from "../Background";
import noPage from "../../Assets/404.png";
import { HouseLine } from "phosphor-react";
import { useNavigate } from "react-router-dom";

const PageNotFound = ({ navigationBar = mainNav }) => {
	const navigate = useNavigate();

	return (
		<Flex height={"100vh"}>
			<Sidebar navRoutes={navigationBar} />
			<Flex direction={"column"} width={"100%"} paddingY={2} paddingX={5}>
				<Box flex={1} marginY={2}>
					<Background heading={"Not available"} key='404'>
						<Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} textAlign={"center"}>
							<img width={"250"} src={noPage} alt='404' />
							<Text fontSize='20px' width={"80%"}>
								This page is not available for you because you might not have enough permission to access it.
							</Text>
							<br />
							<Button
								variant={"solid"}
								colorScheme={"brand"}
								className={"custom-btn"}
								leftIcon={<HouseLine size={20} weight='duotone' />}
								onClick={() => navigate("/")}
							>
								Go to dashboard
							</Button>
						</Box>
					</Background>
				</Box>
			</Flex>
		</Flex>
	);
};

export default PageNotFound;
